<template>
  <div id="app">
    <router-view> </router-view>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
  data() {
    return {
      userActivityThrottlerTimeout: null,
      userActivityTimeout: null,
    };
  },

  beforeMount() {
    this.activateActivityTracker();
  },

  beforeDestroy() {
    window.removeEventListener("mousemove", this.userActivityThrottler);
    window.removeEventListener("scroll", this.userActivityThrottler);
    window.removeEventListener("keydown", this.userActivityThrottler);
    window.removeEventListener("resize", this.userActivityThrottler);

    clearTimeout(this.userActivityTimeout);
    clearTimeout(this.userActivityThrottlerTimeout);
  },

  mounted() {
    // var link = document.querySelector("link[rel~='icon']");
    // if (!link) {
    //     link = document.createElement('link');
    //     link.rel = 'icon';
    //     document.getElementsByTagName('head')[0].appendChild(link);
    // }
    // link.href = '<%= BASE_URL %>safe_favicon.ico';
    this.getUser()
      .then(() => {
        return this.connect();
      })
      .catch((error) => {
        return this.logout().then(() => {
          this.$router.push("/login");
        });
      });
  },

  methods: {
    ...mapActions("user", ["getUser"]),
    ...mapActions("auth", ["logout"]),
    ...mapActions("ws", ["connect"]),
    ...mapMutations("auth", ["setAutoLogout"]),

    resetUserActivityTimeout() {
      clearTimeout(this.userActivityTimeout);
      this.userActivityTimeout = setTimeout(() => {
        this.inactiveUserAction();
      }, this.inactiveUserTimeThreshold);
    },

    activateActivityTracker() {
      window.addEventListener("mousemove", this.userActivityThrottler);
      window.addEventListener("scroll", this.userActivityThrottler);
      window.addEventListener("keydown", this.userActivityThrottler);
      window.addEventListener("resize", this.userActivityThrottler);
    },

    // adding throttler to activateActivityTracker() to fix performance issues
    userActivityThrottler() {
      if (!this.userActivityThrottlerTimeout && !this.isLoginPage()) {
        this.userActivityThrottlerTimeout = setTimeout(() => {
          this.resetUserActivityTimeout();

          clearTimeout(this.userActivityThrottlerTimeout);
          this.userActivityThrottlerTimeout = null;
        }, this.userActivityThrottlerTime);
      }
    },

    // logout inactive users
    inactiveUserAction() {
      this.logout().then(() => {
        this.setAutoLogout(true);
        this.$router.push("/login");
      });
    },

    isLoginPage() {
      return this.$router.currentRoute.path == "/login";
    },
  },

  computed: {
    ...mapState("user", [
      "inactiveUserTimeThreshold",
      "userActivityThrottlerTime",
    ]),
    ...mapGetters(["getUserType"]),
    isObserver() {
      return this.getUserType === "observer";
    },
  },

  head: {
    title: function() {
      return {
        inner: this.isObserver ? "Safe.Doctorplan" : "Provider",
        separator: this.isObserver ? " " : "-",
        complement: this.isObserver ? null : "DoctorPlan",
      };
    },
    link: function() {
      return [
        {
          rel: "icon",
          href: this.isObserver
            ? `${process.env.BASE_URL}safe_favicon.ico`
            : `${process.env.BASE_URL}favicon.ico`,
          sizes: "16x16",
          type: "image/png",
        },
      ];
    },
  },
};
</script>

<style lang="scss">
@import "app.scss";
</style>
